var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MigrationNotificationBanner',{attrs:{"show":_vm.showNotification,"notification":_vm.currentNotification},on:{"action":_vm.handleAction}})}
var staticRenderFns = []

export { render, staticRenderFns }